export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9736.b1c05e0f.jpg";